module.exports = __webpack_public_path__ + "media/images/logo/yunda-4e70b8de9adfec138d7b9fc16ddc4473.gif";